import dayjs from "dayjs";

export const applyDateRangeMask = (value: string = ""): string => {
  if (!value) return "";

  const digits = value.replace(/\D/g, "").slice(0, 16);

  let masked = "";
  if (digits.length > 0) masked += digits.substring(0, 2);
  if (digits.length >= 3) masked += "/" + digits.substring(2, 4);
  if (digits.length >= 5) masked += "/" + digits.substring(4, 8);
  if (digits.length >= 9) masked += " - " + digits.substring(8, 10);
  if (digits.length >= 11) masked += "/" + digits.substring(10, 12);
  if (digits.length >= 13) masked += "/" + digits.substring(12, 16);

  return masked;
};

export const handleDateTypingUtil = (
  from: string,
  to: string,
  setStartDate: (value: string) => void,
  setEndDate: (value: string) => void,
  setDateError: (value: string) => void
) => {
  setStartDate(from);
  setEndDate(to);

  if (!from && !to) {
    setDateError("");
    return;
  }

  const dateFormatRegex = /^\d{2}[/-]\d{2}[/-]\d{4}$/;

  const isStartComplete = dateFormatRegex.test(from);
  const isEndComplete = dateFormatRegex.test(to);

  if (!isStartComplete || !isEndComplete) {
    setDateError("");
    return;
  }

  const normalizedFrom = from.replace(/\//g, "-");
  const normalizedTo = to.replace(/\//g, "-");

  const [fD, fM, fY] = normalizedFrom.split("-").map(Number);
  const [tD, tM, tY] = normalizedTo.split("-").map(Number);

  const start = new Date(fY, fM - 1, fD);
  const end = new Date(tY, tM - 1, tD);

  if (start.getTime() > end.getTime()) {
    setDateError("Data de início não pode ser maior que a de fim.");
  } else {
    setDateError("");
  }
};

export const formatDate = (date: Date) =>
  `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;

const dateFunctions = {
  applyDateRangeMask: applyDateRangeMask,
  formatDate: formatDate,
  handleDateTypingUtil: handleDateTypingUtil,
};

export default dateFunctions;


export const isEndBeforeStart = (start: string, end: string) => {
  return dayjs(end, "DD-MM-YYYY").isBefore(dayjs(start, "DD-MM-YYYY"));
};
